<script lang="ts">
	import type { SbImage } from '../types';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			variant: 'vertical' | 'horizontal' | 'leading-icon';
			value_props: Array<ISbStoryData<{ icon: SbImage; text: string }>['content']>;
			background_variant: 'solid' | 'border';
		}>['content'];
	}

	let { content }: Props = $props();

	let shownProps = $derived(
		content.variant === 'horizontal' ? content.value_props.slice(0, 3) : content.value_props
	);
</script>

<section
	use:editable={content}
	class={[
		'rounded-xl bg-brown-6',
		{
			'px-6 py-4': content.variant === 'horizontal',
			'p-4': content.variant !== 'horizontal',
			'border border-brown-5 bg-transparent': content.background_variant === 'border'
		}
	]}
>
	{#if content.headline}
		<h1
			class="mb-4 text-[16px]/[110%] font-semibold tracking-[-.16px] text-brown-1 lg:text-[20px]/[110%] lg:tracking-[-.2px]"
		>
			{content.headline}
		</h1>
	{/if}
	<ul
		class={[
			'flex items-start justify-between gap-y-2',
			{
				'h-full gap-x-3': content.variant === 'horizontal',
				'flex-col': content.variant !== 'horizontal'
			}
		]}
	>
		{#each shownProps as prop}
			<Blok variant={content.variant} content={prop} class="h-full flex-1" />
		{/each}
	</ul>
</section>
